import { render, staticRenderFns } from "./useSetterList.vue?vue&type=template&id=8233bf40&scoped=true&"
import script from "./useSetterList.vue?vue&type=script&lang=js&"
export * from "./useSetterList.vue?vue&type=script&lang=js&"
import style0 from "./useSetterList.vue?vue&type=style&index=0&id=8233bf40&lang=scss&scoped=true&"
import style1 from "./useSetterList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8233bf40",
  null
  
)

export default component.exports